import { BrowserRouter, Route, Routes } from "react-router-dom";
import { RoutesLink } from "../ApiHelper/RoutesLink";
import ScrollToTop from "../utility/ScrollToTop";
import LandingPage from "../Pages/LandingPage/LandingPage";
import TermsConditions from "../Pages/T&C/TermsConditions";
import PrivacyPolicy from "../Pages/Privacy-Policy/PrivacyPolicy";
import Blog from "../Pages/Blog/Blog";
import BlogDetail from "../Pages/Blog/BlogDetail";
import Faq from "../Pages/FAQ/Faq";
import RefundCancellation from "../Pages/Refund-Cancellation/RefundCancellation";
import ContactUs from "../Pages/ContactUs/ContactUs";
import ReqDeactivate from "../Pages/ReqDeactivate/ReqDeactivate";
import EraseAccountData from "../Pages/EraseAccountData/EraseAccountData";


const CommonRoutes = () => {
  return (
    <ScrollToTop>
      <Routes>
        <Route path={RoutesLink.home} element={<LandingPage />} />
        <Route path={RoutesLink.termsConditions} element={<TermsConditions />} />
        <Route path={RoutesLink.privacy_policy} element={<PrivacyPolicy />} />
        <Route path={RoutesLink.RefundCancellation} element={<RefundCancellation />} />
        <Route path={RoutesLink.ReqDeactivate} element={<ReqDeactivate />} />
        <Route path={RoutesLink.EraseData} element={<EraseAccountData />} />
        <Route path={RoutesLink.ContactUs} element={<ContactUs />} />
        <Route path={RoutesLink.blog} element={<Blog />} />
        {/* <Route path={RoutesLink.faq} element={<Faq />} /> */}
        <Route path={RoutesLink.blog_detail + "/:id/:slug"} element={<BlogDetail />} />
      </Routes>
    </ScrollToTop>
  );
};
export default CommonRoutes;
